import { BodyText, AllowedIcons, Icon } from "@gnist/design-system";
import { styled } from "styled-components";
import { tokens } from "@gnist/themes/tokens.css.js";

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-width: 156px;
  gap: ${tokens.spacing.xs};
`;

interface Props {
  label: string;
  value: string;
  icon: AllowedIcons;
}

export const HighlightElement = ({ label, value, icon }: Props) => {
  return (
    <Wrapper>
      <Icon size={"xl"} icon={icon} />
      <div>
        <dt>{label}</dt>
        <BodyText
          style={{ fontWeight: tokens.typeface.weight.semibold }}
          $as="dd"
        >
          {value}
        </BodyText>
      </div>
    </Wrapper>
  );
};
